"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutboundAllowedCounterparties = exports.PaymentEvent = exports.OutboundPaymentFreezeReason = exports.OutboundPaymentCancelReason = exports.OutboundReleaseFlag = exports.OutboundMethod = exports.OutboundPaymentCharges = exports.OutboundPaymentMethod = exports.SFPaymentStatus = exports.OutboundPaymentStatus = void 0;
var OutboundPaymentStatus;
(function (OutboundPaymentStatus) {
    OutboundPaymentStatus["HELD"] = "Held";
    OutboundPaymentStatus["MANUAL_RELEASE"] = "Manual Release";
    OutboundPaymentStatus["RELEASE_QUEUE"] = "Release Queue";
    OutboundPaymentStatus["QUEUED"] = "Queued";
    OutboundPaymentStatus["SENT_PENDING"] = "Sent - Pending";
    OutboundPaymentStatus["SENT_COMPLETE"] = "Sent - Complete";
    OutboundPaymentStatus["DEBIT_PENDING"] = "Debit - Pending";
    OutboundPaymentStatus["FAILED"] = "Failed";
    OutboundPaymentStatus["VOID"] = "Void";
})(OutboundPaymentStatus = exports.OutboundPaymentStatus || (exports.OutboundPaymentStatus = {}));
var SFPaymentStatus;
(function (SFPaymentStatus) {
    SFPaymentStatus["PENDING_SUBMISSION"] = "Pending Submission";
    SFPaymentStatus["APPROVED"] = "Approved";
    SFPaymentStatus["REJECTED"] = "Rejected";
})(SFPaymentStatus = exports.SFPaymentStatus || (exports.SFPaymentStatus = {}));
var OutboundPaymentMethod;
(function (OutboundPaymentMethod) {
    OutboundPaymentMethod["SEPA"] = "SEPA";
    OutboundPaymentMethod["FPS"] = "FPS";
    OutboundPaymentMethod["CHAPS"] = "CHAPS";
    OutboundPaymentMethod["XCT"] = "XCT";
    OutboundPaymentMethod["IAT"] = "IAT";
    OutboundPaymentMethod["DFT"] = "DFT";
    OutboundPaymentMethod["ACH"] = "ACH";
})(OutboundPaymentMethod = exports.OutboundPaymentMethod || (exports.OutboundPaymentMethod = {}));
var OutboundPaymentCharges;
(function (OutboundPaymentCharges) {
    OutboundPaymentCharges["OUR"] = "OUR";
    OutboundPaymentCharges["SHA"] = "SHA";
    OutboundPaymentCharges["BEN"] = "BEN";
})(OutboundPaymentCharges = exports.OutboundPaymentCharges || (exports.OutboundPaymentCharges = {}));
var OutboundMethod;
(function (OutboundMethod) {
    OutboundMethod["SWIFT"] = "SWIFT";
    OutboundMethod["MANUAL"] = "Manual";
})(OutboundMethod = exports.OutboundMethod || (exports.OutboundMethod = {}));
var OutboundReleaseFlag;
(function (OutboundReleaseFlag) {
    OutboundReleaseFlag["HELD"] = "Held";
    OutboundReleaseFlag["INSTANT"] = "Instant";
})(OutboundReleaseFlag = exports.OutboundReleaseFlag || (exports.OutboundReleaseFlag = {}));
var OutboundPaymentCancelReason;
(function (OutboundPaymentCancelReason) {
    OutboundPaymentCancelReason["DEALER_REQUESTED"] = "Dealer requested";
    OutboundPaymentCancelReason["CLIENT_REQUESTED"] = "Client requested";
    OutboundPaymentCancelReason["INVALID_BANK_DETAILS"] = "Invalid bank details";
    OutboundPaymentCancelReason["DUPLICATE_PAYMENT"] = "Duplicate Payment";
    OutboundPaymentCancelReason["NO_LONGER_REQUIRED"] = "No Longer required";
    OutboundPaymentCancelReason["INCORRECT_AMOUNT"] = "Incorrect amount";
    OutboundPaymentCancelReason["WRONG_BENEFICIARY"] = "Wrong Beneficiary";
})(OutboundPaymentCancelReason = exports.OutboundPaymentCancelReason || (exports.OutboundPaymentCancelReason = {}));
var OutboundPaymentFreezeReason;
(function (OutboundPaymentFreezeReason) {
    OutboundPaymentFreezeReason["INVALID_BANK_DETAILS"] = "Invalid bank details";
    OutboundPaymentFreezeReason["INVALID_PURPOSE_OF_PAYMENT"] = "Invalid Purpose of Payment";
    OutboundPaymentFreezeReason["POTENTIAL_DUPLICATE"] = "Potential duplicate";
    OutboundPaymentFreezeReason["DELEAR_REQUEST"] = "Dealer requested";
    OutboundPaymentFreezeReason["CLIENT_REQUEST"] = "Client requested";
    OutboundPaymentFreezeReason["MISSING_INFORMATION"] = "Missing information";
})(OutboundPaymentFreezeReason = exports.OutboundPaymentFreezeReason || (exports.OutboundPaymentFreezeReason = {}));
var PaymentEvent;
(function (PaymentEvent) {
    PaymentEvent["CREATED"] = "created";
    PaymentEvent["CANCELLED"] = "cancelled";
    PaymentEvent["COMPLETED"] = "completed";
    PaymentEvent["FROZEN"] = "frozen";
    PaymentEvent["UNFROZEN"] = "unfrozen";
    PaymentEvent["CREDIT_BLOCKED"] = "credit_blocked";
    PaymentEvent["CREDIT_UNBLOCKED"] = "credit_unblocked";
    PaymentEvent["COMPLIANCE_BLOCKED"] = "compliance_blocked";
    PaymentEvent["COMPLIANCE_UNBLOCKED"] = "compliance_unblocked";
    PaymentEvent["RELEASED"] = "released";
    PaymentEvent["FAILED"] = "failed";
    PaymentEvent["DEBIT_PENDING"] = "debit-pending";
})(PaymentEvent = exports.PaymentEvent || (exports.PaymentEvent = {}));
var OutboundAllowedCounterparties;
(function (OutboundAllowedCounterparties) {
    OutboundAllowedCounterparties["Barclays"] = "Barclays Bank";
    OutboundAllowedCounterparties["Citi"] = "Citi Bank";
})(OutboundAllowedCounterparties = exports.OutboundAllowedCounterparties || (exports.OutboundAllowedCounterparties = {}));
